import BaseService from "./geral/BaseService";

const base = "Container";

export default class ContainersService extends BaseService {
    constructor() {
        super(base);
    }

    detalhar (containerId) {
        return super.httpGet(`/${base}/Detalhe?cntrNbr=${containerId}`); // TODO Precisa receber da tela pai
    }

    listar (filtro) {
        return super.httpGet(`/${base}/Listar?${filtro}`);
    }

    relatorio (unitId) {
        return super.httpGet(`/${base}/Relatorio/${unitId}`);
    }
    
    relatorioPessagem (unitId) {
        return super.httpGet(`/${base}/RelatorioPesagem/${unitId}`);
    }
}



// WEBPACK FOOTER //
// ./src/services/ContainersService.js